var _ellipse, _ellipse2, _ellipse3, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse4, _ellipse5, _ellipse6, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _line, _line2, _line3, _path31, _path32, _circle, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 621,
    height: 366,
    viewBox: "0 0 621 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.5,
    cy: 222,
    rx: 189.5,
    ry: 43,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.5,
    cy: 243,
    rx: 189.5,
    ry: 43,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11446_43935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 179,
    width: 379,
    height: 87
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.5,
    cy: 222.132,
    rx: 189.5,
    ry: 43.1325,
    fill: "black",
    fillOpacity: 0.08
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11446_43935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.5,
    cy: 241.793,
    rx: 189.5,
    ry: 43.1325,
    fill: "#1F1F1F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.029 227.547L243.38 59.968C244.737 56.1356 248.982 54.11 252.812 55.4667L457.992 128.135C461.823 129.492 463.847 133.737 462.489 137.57L403.138 305.149L184.029 227.547Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M441.814 143.383L255.787 77.4976L213.377 197.242L399.405 263.127L441.814 143.383Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.879 269.253L333.819 277.893L254.526 249.81L257.586 241.17L173 211.212L164.597 234.938L413.063 322.937L421.466 299.211L336.879 269.253Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.025 222.701H125V365.534H504V222.701H503.975C502.316 246.197 418.12 265.127 314.5 265.127C210.88 265.127 126.684 246.197 125.025 222.701Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.941 154.026L91.4072 171.323",
    stroke: "#696969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0259 157.408L105.322 167.941",
    stroke: "#696969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6056 168.28C76.7016 181.021 89.5395 188.839 102.28 185.743C115.02 182.647 122.839 169.809 119.743 157.069C116.647 144.328 103.809 136.51 91.0685 139.606C78.3281 142.702 70.5097 155.54 73.6056 168.28Z",
    stroke: "#696969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143,
    cy: 301.786,
    rx: 63,
    ry: 17.7858,
    fill: "#D9D9D9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143,
    cy: 310.472,
    rx: 63,
    ry: 17.7858,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11446_43935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 284,
    width: 126,
    height: 36
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143,
    cy: 301.841,
    rx: 63,
    ry: 17.8405,
    fill: "black",
    fillOpacity: 0.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11446_43935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 144,
    cy: 313.121,
    rx: 63,
    ry: 21.5,
    fill: "#1F1F1F"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0083 302.076H80V361.154H206V302.076H205.992C205.44 311.794 177.449 319.624 143 319.624C108.551 319.624 80.5598 311.794 80.0083 302.076Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 319V299C127.5 281.327 113.173 267 95.5 267H94.5V267C80.6929 267 69.5 278.193 69.5 292V307V307C69.5 313.627 64.1274 319 57.5 319H38",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M578.94 220.16L576.88 211",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M593.01 282.72L590.95 273.56",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M584.83 274.25C599.941 274.25 612.19 262.001 612.19 246.89C612.19 231.779 599.941 219.53 584.83 219.53C569.72 219.53 557.47 231.779 557.47 246.89C557.47 262.001 569.72 274.25 584.83 274.25Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M584.83 257.94C590.938 257.94 595.89 252.988 595.89 246.88C595.89 240.772 590.938 235.82 584.83 235.82C578.722 235.82 573.77 240.772 573.77 246.88C573.77 252.988 578.722 257.94 584.83 257.94Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M611.52 240.8L620.67 238.71",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M549 255.06L558.15 252.97",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M599.66 223.71L604.68 215.78",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M565.37 277.9L570.39 269.97",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M608.1 261.34L616.05 266.34",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M553.81 227.22L561.76 232.22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M551.87 205.81L556.26 203.3",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M521.9 222.97L526.29 220.46",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M539.05 227.81C547.185 227.81 553.78 221.215 553.78 213.08C553.78 204.945 547.185 198.35 539.05 198.35C530.915 198.35 524.32 204.945 524.32 213.08C524.32 221.215 530.915 227.81 539.05 227.81Z",
    fill: "white",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M539.05 219.03C542.336 219.03 545 216.366 545 213.08C545 209.794 542.336 207.13 539.05 207.13C535.764 207.13 533.1 209.794 533.1 213.08C533.1 216.366 535.764 219.03 539.05 219.03Z",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M546.41 225.85L548.94 230.23",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M529.16 195.94L531.69 200.32",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M553.32 217.04L558.2 218.37",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M520 207.99L524.88 209.31",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M535.3 227.35L533.99 232.23",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M544.25 194L542.94 198.88",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9 307H25.5C31.8513 307 37 312.149 37 318.5C37 324.851 31.8513 330 25.5 330H9V307Z",
    stroke: "#1F1F1F",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 312,
    x2: 8,
    y2: 312,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 325,
    x2: 8,
    y2: 325,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 306,
    x2: 23,
    y2: 331,
    stroke: "black",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M226.154 44.6465V44.6465C232.803 33.18 247.489 29.2747 258.955 35.9238V35.9238",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M211 34.6032V34.6032C222.082 15.4924 246.558 8.98358 265.669 20.0654V20.0654",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 490.661,
    cy: 82.6612,
    r: 26.3779,
    fill: "#F5F5F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M496.835 75.5848C496.835 74.2181 496.327 73.1274 495.311 72.3127C494.295 71.4979 492.941 71.0906 491.248 71.0906C489.79 71.0906 488.422 71.3928 487.146 71.9973C485.896 72.6018 484.867 73.4559 484.06 74.5598L482.653 73.1011C483.539 71.8659 484.75 70.8803 486.287 70.1444C487.823 69.3822 489.477 69.0012 491.248 69.0012C493.67 69.0012 495.584 69.5925 496.991 70.7752C498.423 71.9316 499.139 73.5085 499.139 75.5059C499.139 76.5046 498.983 77.3719 498.671 78.1078C498.358 78.8174 497.837 79.4876 497.108 80.1184C496.405 80.7491 495.454 81.3799 494.256 82.0107C493.475 82.4049 492.863 82.7991 492.42 83.1933C491.977 83.5876 491.665 84.0738 491.482 84.652C491.3 85.2039 491.209 86.0186 491.209 87.0962V88.8308H488.982V87.0962C488.982 85.7821 489.099 84.744 489.334 83.9818C489.568 83.1933 489.985 82.51 490.584 81.9318C491.209 81.3273 492.081 80.7491 493.201 80.1972C494.478 79.5665 495.402 78.8963 495.975 78.1867C496.548 77.4508 496.835 76.5835 496.835 75.5848ZM490.115 96.3211C489.568 96.3211 489.125 96.1503 488.787 95.8086C488.448 95.4407 488.279 94.9939 488.279 94.4682C488.279 93.9426 488.448 93.509 488.787 93.1673C489.125 92.7993 489.568 92.6154 490.115 92.6154C490.662 92.6154 491.105 92.7993 491.443 93.1673C491.782 93.509 491.951 93.9426 491.951 94.4682C491.951 94.9939 491.782 95.4407 491.443 95.8086C491.105 96.1503 490.662 96.3211 490.115 96.3211Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error_404.3ceacdf6982ba31fce4d683ced767458.svg";
export { ForwardRef as ReactComponent };